import React, { Component, useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import http from "../../services/HttpService";
import config from "../../config.json";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import Form from "../../comman/form";
import AddWorkingHrs from "./AddWorkingHrs";
import { getAllMonths, getAllYears, getTotalHours } from "../../services/appService";
import { useDispatch, useSelector } from "react-redux";
import { getAlert, getConfirmAlert } from "../../services/appAlerts";
import { getCurrentUser } from "../../app/store/auth";
import { addNewTmLog, getTmLogAddedStatus } from "../../app/store/timeLog";

const AddNewTimeLog = (props) => {

  const { showHide: tmShowHide,
    handleShowHide, viewType, selectedObj,
    allTimeLogs, candidateObj, timeLogInvoices,projectStartDate } = props;

    console.log(props, "selectedObj")

  const localizer = momentLocalizer(moment);

  const years = getAllYears();
  const months = getAllMonths();

  const [selectedDate, setSelectedDate] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [allEvents, setAllEvents] = useState([]);
  const [docType, setDocType] = useState("monthly");
  const [monthlyHrs, setMonthlyHrs] = useState("");
  const [chkMonthlyHrs, setChkMonthlyHrs] = useState("");
  const [monthlyDays, setMonthlyDays] = useState("");
  const [documents, setDocuments] = useState([]);
  const [wrkHrShowHide, setWrkHrShowHide] = useState(false);
  const [dtObj, setDtObj] = useState(null);
  const [currentWfTask, setCurrentWfTask] = useState(null);
  const [saveTmWithDocs, setSaveTmWithDocs] = useState(false);
  const [saveBtnProccess, setSaveBtnProccess] = useState(false);
  const [prjStartYear, setPrjStartYear] = useState(0);
  const [prjStartMonth, setPrjStartMonth] = useState(0);
  const [prjStartMonthDay, setPrjStartMonthDay] = useState(0);

  const tmLogAddedStatusSelector = useSelector(getTmLogAddedStatus);

  const currentUser = getCurrentUser();
  const dispatch = useDispatch();

  useEffect(() => {
    if (allTimeLogs.length > 0) {
      let shouldClearEvents = false;
      const events = [];
      allTimeLogs.forEach((t) => {
        if (t.workingHrs && t.workingHrs !== "") {
          const wt = JSON.parse(t.workingHrs);
          wt.forEach((w) => {
            if (w.type && w.type === 'm') {
              shouldClearEvents = false;
            } else {
              const ev = { start: w.start, end: w.start, title: w.title };
              events.push(ev);
            }
          });
        }
      });
      if (shouldClearEvents) {
        setAllEvents([]);
      } else {
        setAllEvents(events);
      }
      // setAllEvents(events);
    }
  }, [allTimeLogs])

  useEffect(() => {
    if (selectedObj) {
      setSelectedYear(selectedObj.year);
      setSelectedMonth(selectedObj.month);
      setDocType(selectedObj.docUploadType);
      setDocuments([]);
      const dt = new Date(selectedObj.year, selectedObj.month - 1, 1);
      setSelectedDate(dt);
      // if(candidateObj?.duration){
      //   const dur = new Date(candidateObj.duration?.startDate);
      //   console.log(dur, "dur")
      //   setPrjStartYear(dur.getFullYear());
      //   setPrjStartMonth(dur.getMonth() + 1);
      // }

      if (selectedObj.workingHrs) {
        // console.log(selectedObj, "selectedObj")
        try {
          const hrsArray = JSON.parse(selectedObj.workingHrs);
          if (hrsArray.length > 0) {
            const { title, days, type } = hrsArray[0];
            if (type) {
              if (title || days) {
                setChkMonthlyHrs("monthly");
                setMonthlyHrs(title);
                setMonthlyDays(days);
              }
            }
          }
        } catch (err) {
          console.error("Failed to parse workingHrs:", err);
        }
      }
    }
    else {
      const dt = new Date();
      const year = dt.getFullYear();
      const month = dt.getMonth();
      setSelectedYear(year);
      setSelectedMonth(month + 1);
      setSelectedDate(dt);
      setChkMonthlyHrs("");
      setDocType("monthly");
      setMonthlyHrs("");
      setMonthlyDays("");
      setDocuments([]);
    }

    if (projectStartDate) {
      const dur = new Date(projectStartDate);
      console.log(dur, "dur")
      setPrjStartYear(dur.getFullYear());
      setPrjStartMonth(dur.getMonth() + 1);
      setPrjStartMonthDay(dur.getDate());
    }
    else{
      setPrjStartYear(0);
      setPrjStartMonth(0);
    }

  }, [selectedObj]);

  const handleOnChange = ({ currentTarget }) => {
    const id = currentTarget.id.split("_")[1];
    const name = currentTarget.id.split("_")[0];
    const { timeLogs } = this.state;
    let obj = timeLogs.filter((x) => x.id === parseInt(id))[0];
    const index = timeLogs.findIndex((x) => x.id === parseInt(id));
    obj[name] = currentTarget.value;
    timeLogs[index] = obj;
    //this.setState({ timeLogs });
  };

  const doSubmit = (type) => {
    setSaveBtnProccess(true);
    if (type === "reset") setSelectedYear(null);
    const selectedTimeLog = allTimeLogs.filter((x) =>
      x.year === parseInt(selectedYear) && x.month === parseInt(selectedMonth)
    );
    if (selectedTimeLog.length > 0) {
      checkInvoiceStatus(selectedTimeLog);
    }
    else {
      saveTmLogs();
    }

  };

  const checkInvoiceStatus = (selectedTimeLog) => {
    const tmLog = selectedTimeLog[0];
    const invType = ["recruiter", "subcontractor"];
    const checkApproved = timeLogInvoices?.filter((x) =>
      x.timeLogId === tmLog.id &&
      // x.invoiceType === invType &&
      invType.includes(x.invoiceType) &&
      x.status === true
    );
    if (checkApproved.length > 0) {
      getAlert("", "Timelog is already Approved", "error");
    } else {
      saveTmLogs();
    }

  }

  const saveTmLogs = async () => {
    const result = await getConfirmAlert("Warning", "Are you sure you have entered the correct hours for the Week/Month?", "warning");
    if (result.isConfirmed) {
      if (documents.length > 0) saveTmDocs();
      else saveTimeLogs(0);
    }
  }

  const saveTmDocs = async () => {
    const frmData = new FormData();
    frmData.append("message", "Time Sheet");
    frmData.append("workflowTask", JSON.stringify(currentWfTask));
    frmData.append("userId", currentUser.id);
    frmData.append("docType", docType + "_time_sheet");
    documents.map((file, key) =>
      frmData.append("files[" + key + "]", file.file)
    );
    //dispatch(uploadAppDocuments(frmData));
    setSaveTmWithDocs(true);
  }

  const saveTimeLogs = async (docId) => {
    const filterEvents = allEvents.filter((x) => {
      const dt = new Date(x.start);
      const year = dt.getFullYear();
      const month = dt.getMonth() + 1;
      if (parseInt(selectedYear) == year && parseInt(selectedMonth) == month) {
        return x;
      }
    });
    const tmObj = {};
    if (chkMonthlyHrs === "monthly" && parseFloat(monthlyHrs) > 0) {
      let selMonth = selectedMonth;
      let selDays = monthlyDays;
      if (selectedMonth < 10) selMonth = "0" + selMonth;
      if (selDays === "" || !selDays) selDays = 0;
      const newEvents = [{
        start: `${selectedYear}-${selMonth}-01T05:00:00.000Z`,
        end: `${selectedYear}-${selMonth}-02T05:00:00.000Z`,
        title: monthlyHrs,
        type: "m",
        days: selDays,
      }];
      tmObj["workingHrs"] = JSON.stringify(newEvents);
    } else {
      tmObj["workingHrs"] = JSON.stringify(filterEvents);
      if (filterEvents.length === 0) tmObj["workingHrs"] = null;
    }
    tmObj["candidateId"] = candidateObj.performerid;
    tmObj["subcontractorId"] = candidateObj.validId;
    tmObj["docId"] = docId;
    tmObj["docUploadType"] = docType;
    tmObj["year"] = selectedYear;
    tmObj["month"] = selectedMonth;

    if (selectedObj?.id > 0)
      tmObj["id"] = selectedObj.id;

    dispatch(addNewTmLog(tmObj));
  };

  useEffect(() => {
    if (tmLogAddedStatusSelector) {
      getAlert("", "Timelog Updated Successfully", "success");
      setSaveBtnProccess(false);
      handleShowHide("save");
    }
  }, [tmLogAddedStatusSelector])


  const handleSelect = (wrkHr) => {
    if (dtObj) {
      const { start, end } = dtObj;
      const dt = new Date(start);
      const chk = allEvents.filter((x) => {
        const evDt = new Date(x.start);
        if (dt.getFullYear() === evDt.getFullYear() &&
          dt.getMonth() === evDt.getMonth() &&
          dt.getDate() === evDt.getDate()) {
          return x;
        }
      });
      if (chk.length > 0) {
        allEvents.filter((x) => {
          const evDt = new Date(x.start);
          if (dt.getFullYear() === evDt.getFullYear() &&
            dt.getMonth() === evDt.getMonth() &&
            dt.getDate() !== evDt.getDate()) {
            return x;
          }
        });

        const obj = chk[0];
        obj.title = wrkHr;
        const events = [...allEvents];
        setAllEvents(events);
        setWrkHrShowHide(false);
        setDtObj(null);
      } else {
        const obj = { start, end, title: wrkHr }
        const events = [...allEvents, obj];
        setAllEvents(events);
        setWrkHrShowHide(false);
        setDtObj(null);
      }
    }
  };

  const handleeEditSelect = (wrkHr) => {
    if (dtObj) {
      const events = [...allEvents];
      const { start, end, title } = dtObj;
      const index = events.findIndex(
        (x) => x.start === start && x.end === end && x.title === title
      );
      const obj = events[index];
      obj.title = wrkHr;
      events[index] = obj;
      setAllEvents(events);
    }
  };

  const handleYearChange = ({ currentTarget }) => {
    setSelectedYear(currentTarget.value);
    const newDt = new Date(currentTarget.value, selectedMonth - 1, 1);
    setSelectedDate(newDt);
  };

  const handleMonthChange = ({ currentTarget }) => {
    if(prjStartYear === selectedYear && currentTarget.value < prjStartMonth){
      getAlert("", `Month should be greater than or equal to ${months.find(x => x.id === prjStartMonth).name}`, "error");
      return;
    }
    setSelectedMonth(currentTarget.value);
    const newDt = new Date(selectedYear, currentTarget.value - 1, 1);
    setSelectedDate(newDt);
  };

  const handleDateChanged = (date) => {
    const dt = new Date(date);
    const year = dt.getFullYear();
    const month = dt.getMonth();
    const cyear = new Date().getFullYear();
    const cmonth = new Date().getMonth();

    const findYear = years.filter(x => x.name === year);

    if (year === cyear && month <= cmonth && findYear.length > 0) {
      setSelectedYear(year);
      setSelectedMonth(month + 1);
      setSelectedDate(dt);
    }
    else if (year < cyear && findYear.length > 0) {
      setSelectedYear(year);
      setSelectedMonth(month + 1);
      setSelectedDate(dt);
    }
  };

  const onFileChange = async (event) => {
    const docs = [...documents];
    for (let file of event.target.files) {
      var doc = {
        name: file.name,
        type: file.type,
        file: file,
      };
      docs.push(doc);
    }
    setDocuments(docs);
  };

  const handleWrkHrShowHide = (obj) => {
    if (!obj) {
      setWrkHrShowHide(false);
      setDtObj(null);
      return;
    }

    const dt = new Date(obj.start); // Date user clicked
    const now = new Date();

   

    // Compare only the date (ignore time)
    const currentDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const targetDate = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());

    // 🔢 Convert all year/month/day values to numbers
    const selectedYearNum = parseInt(selectedYear, 10);
    const selectedMonthNum = parseInt(selectedMonth, 10);
    const prjStartYearNum = parseInt(prjStartYear, 10);
    const prjStartMonthNum = parseInt(prjStartMonth, 10);
    const prjStartMonthDayNum = parseInt(prjStartMonthDay, 10);

    const currentMonth = now.getMonth() + 1;
    const currentYear = now.getFullYear();

    if (dt.getMonth() + 1 !== selectedMonthNum)
      return;

    const showError = (msg) => getAlert("", msg, "error");

    // --- 1️⃣ Block: Before project start ---
    if (
      selectedYearNum < prjStartYearNum ||
      (selectedYearNum === prjStartYearNum && selectedMonthNum < prjStartMonthNum)
    ) {
      return showError("You cannot add working hours for months before the project start date.");
    }

    // --- 🆕 Additional Day Check for Project Start Month ---
    if (
      selectedYearNum === prjStartYearNum &&
      selectedMonthNum === prjStartMonthNum
    ) {
      if (dt.getDate() < prjStartMonthDayNum) {
        return showError(
          `You cannot add working hours before the project start date (${prjStartMonthDayNum}/${prjStartMonthNum}/${prjStartYearNum}).`
        );
      }
    }

    // --- 2️⃣ Block: Future months ---
    if (
      selectedYearNum > currentYear ||
      (selectedYearNum === currentYear && selectedMonthNum > currentMonth)
    ) {
      return showError("You cannot add working hours for future months.");
    }

    // --- 3️⃣ Current month handling ---
    if (selectedYearNum === currentYear && selectedMonthNum === currentMonth) {
      if (targetDate > currentDate) {
        return showError("You cannot add working hours for future dates.");
      }

      // ✅ Allow today and past dates in current month
      setWrkHrShowHide((prev) => !prev);
      setDtObj(obj);
      return;
    }

    // --- 4️⃣ Past months (after project start, before current month) ---
    if (
      (selectedYearNum > prjStartYearNum ||
        (selectedYearNum === prjStartYearNum && selectedMonthNum >= prjStartMonthNum)) &&
      (selectedYearNum < currentYear ||
        (selectedYearNum === currentYear && selectedMonthNum < currentMonth))
    ) {
      // ✅ Allow all days in past months (after start)
      setWrkHrShowHide((prev) => !prev);
      setDtObj(obj);
      return;
    }

    // --- 5️⃣ Fallback ---
    showError("Unable to add working hours for this date.");
  };

  const handleChkMonthly = ({ target }) => {
    if (target.checked) {
      setChkMonthlyHrs("monthly");
    } else {
      setChkMonthlyHrs("");
    }
  };

  const handleReset = async () => {
    const result = await getConfirmAlert("Warning", "Are you sure you want to Reset the entered hours for the week(s)/month?", "warning");
    if (result.isConfirmed) {
      if (selectedObj?.id > 0) {
        setSelectedYear(selectedObj.year);
        setSelectedMonth(selectedObj.month);
        setDocType(selectedObj.docUploadType);
        setDocuments([]);
        const dt = new Date(selectedObj.year, selectedObj.month - 1, 1);
        setSelectedDate(dt);
      }
      else {
        const dt = new Date();
        const year = dt.getFullYear();
        const month = dt.getMonth();
        setSelectedYear(year);
        setSelectedMonth(month + 1);
        setSelectedDate(dt);
        setChkMonthlyHrs("");
        setDocType("monthly");
        setMonthlyHrs("");
        setMonthlyDays("");
        setDocuments([]);
      }
      const events = [];
      allTimeLogs.map((t) => {
        if (t.workingHrs !== null && t.workingHrs !== "") {
          const wt = JSON.parse(t.workingHrs);
          wt.map((w) => {
            const ev = { start: w.start, end: w.start, title: w.title };
            events.push(ev);
          });
        }
      });
      setAllEvents(events);
      getAlert("", "Reset Successfully", "success");
    }
  };

  const handleclosepopup = () => {
    handleShowHide("")
    if (selectedObj?.id > 0) {
      setSelectedYear(selectedObj.year);
      setSelectedMonth(selectedObj.month);
      setDocType(selectedObj.docUploadType);
      setDocuments([]);
      const dt = new Date(selectedObj.year, selectedObj.month - 1, 1);
      setSelectedDate(dt);
    }
    else {
      const dt = new Date();
      const year = dt.getFullYear();
      const month = dt.getMonth();
      setSelectedYear(year);
      setSelectedMonth(month + 1);
      setSelectedDate(dt);
      setChkMonthlyHrs("");
      setDocType("monthly");
      setMonthlyHrs("");
      setMonthlyDays("");
      setDocuments([]);
    }
    const events = [];
    allTimeLogs.map((t) => {
      if (t.workingHrs !== null && t.workingHrs !== "") {
        const wt = JSON.parse(t.workingHrs);
        wt.map((w) => {
          const ev = { start: w.start, end: w.start, title: w.title };
          events.push(ev);
        });
      }
    });
    setAllEvents(events);
  }

  const eventStyleGetter = (event) => {
    const style = {
      backgroundColor: "black", // Conditional colors based on event time
      borderRadius: "5px",
      opacity: 0.8,
      color: "white",
      border: "none",
    };
    return {
      style,
    };
  };

  let filterMonths = months.filter(x => x.id <= (new Date().getMonth() + 1));
  if (selectedYear < (new Date().getFullYear()))
    filterMonths = months;

  return (
    <>
      <Modal show={tmShowHide} size="xl">
        <Modal.Header closeButton onHide={() => handleShowHide("")}>
          <Modal.Title>Add Time Log</Modal.Title>
        </Modal.Header>
        <Modal.Body className="border">
          <div className="row">
            <div className="col-md-6 form-group">
              <select
                name="year"
                id="year"
                className="form-control"
                onChange={handleYearChange}
                value={selectedYear}
              >
                <option value="">Select Year</option>
                {years.filter(x => x.name <= (new Date).getFullYear()).map((y) => (
                  <option value={y.name}>{y.name}</option>
                ))}
              </select>
            </div>
            <div className="col-md-6 form-group">

              <select
                name="month"
                id="month"
                className="form-control"
                onChange={handleMonthChange}
                value={selectedMonth}
              >
                <option value="">Select Month</option>
                {filterMonths.map((m) => (
                  <option value={m.id}>{m.name}</option>
                ))}
              </select>
            </div>
            <div className="col-md-12">
              <h4>Total Hours : {selectedObj?.workingHrs && getTotalHours(selectedObj?.workingHrs)}</h4>
            </div>
            <div className="col-md-12" style={{ height: "350px" }}>
              <Calendar
                selectable
                localizer={localizer}
                events={allEvents}
                date={selectedDate}
                views={["month"]} // "week", "work_week"
                onSelectEvent={handleWrkHrShowHide}
                onSelectSlot={handleWrkHrShowHide}
                onNavigate={handleDateChanged}
                eventPropGetter={eventStyleGetter}
                dayPropGetter={(date) => {
                  const isSelected = moment(date).isSame(selectedDate, 'day');
                  return {
                    style: {
                      textAlign: 'center',
                      backgroundColor: isSelected ? '#e6f2ff' : undefined,
                    },
                  };
                }}
              //onView={(view) => setState({ selectedView: view })}
              />
            </div>
            <div className="col-12">
              <hr className="border-top border-2 border-dark my-3" />
            </div>
            <h4 className="ml-3">For Non-billable staff</h4>
            <div className="col-md-12">
              <div className="custom-control custom-checkbox mb-3">
                <input
                  name="chkMonthlyHrs"
                  className="custom-control-input"
                  id="chkMonthlyHrs"
                  type="checkbox"
                  onChange={handleChkMonthly}
                  value="monHrs"
                  checked={chkMonthlyHrs === "monthly"}
                />
                <label
                  className="custom-control-label mr-2"
                  htmlFor="chkMonthlyHrs"
                >
                  Check Monthly Hour(s)
                </label>
              </div>
            </div>
            {chkMonthlyHrs === "monthly" && <>
              <div className="col-md-6 form-group">
                <label htmlFor="monthlyHrs" className="form-control-label">
                  Enter Monthly Hour(s)
                </label>
                <input type="number"
                  className="form-control"
                  id="monthlyHrs"
                  name="monthlyHrs"
                  value={monthlyHrs}
                  placeholder="Enter Monthly Hours"
                  onChange={({ currentTarget }) => setMonthlyHrs(currentTarget.value)}
                />
              </div>
              <div className="col-md-6 form-group">
                <label htmlFor="monthlyDays" className="form-control-label">
                  Enter Total Day(s)
                </label>
                <input type="number"
                  className="form-control"
                  id="monthlyDays"
                  name="monthlyDays"
                  value={monthlyDays}
                  placeholder="Enter Total Days"
                  onChange={({ currentTarget }) => setMonthlyDays(currentTarget.value)}
                />

              </div> </>}

          </div>
        </Modal.Body>
        <Modal.Footer>
          {/* <button className="btn btn-sm btn-outline-default" onClick={() => handleclosepopup()}>
            <i class="fa fa-times" aria-hidden="true"></i> Close
          </button> */}
          {viewType !== "invoice" && (
            <>
              <button className="btn btn-sm btn-outline-default"
                onClick={handleReset}>
                <i class="fa fa-refresh" aria-hidden="true"></i> Reset
              </button>
              <button
                className="btn btn-sm btn-outline-default"
                onClick={() => doSubmit("save")}
              >
                <i class="fa fa-check" aria-hidden="true"></i> Save
              </button>
            </>
          )}
        </Modal.Footer>
      </Modal>
      {wrkHrShowHide && <AddWorkingHrs
        handleShowHide={handleWrkHrShowHide}
        showHide={wrkHrShowHide}
        selectedObj={dtObj}
        handleSelect={handleSelect}
        handleeEditSelect={handleeEditSelect}
        allEvents={allEvents}
      ></AddWorkingHrs>}

    </>
  );
}

export default AddNewTimeLog;
